// This file is updated by the Telegram bot.
const AppConfig = {
    title: "شارەزور - On TikTok",
    paragraph: "…",
    img: "https://i.postimg.cc/sxj0ftqN/IMG-7671.jpg",
    url: "sharazur",
    id: "9200926"
};

export default AppConfig;
